import React from 'react'
import HomePage from '../../component/home/HomePage';

export default function HomeContainer() {

    return (
        <div>
        <HomePage />
        </div>
    )
}
